const resolveLocaleAssets = (banner, lang) =>
	banner.locales[lang] ?? banner.locales[banner.fallbackLocale];

export const resolveHomeBannerAssets = (banner, lang) => {
	const localeAssets = resolveLocaleAssets(banner, lang);

	return {
		id: banner.id,
		href: banner.href,
		desktopSrc: localeAssets.desktopSrc,
		mobileSrc: localeAssets.mobileSrc,
		alt: localeAssets.alt,
	};
};

export const resolveHomeBanners = (banners, lang) =>
	banners.map((banner) => resolveHomeBannerAssets(banner, lang));
